import { Loading01Icon } from '@langchain/untitled-ui-icons';

import { cn } from '../../utils/cn';

const Spinner = ({ size = 'sm' }: { size?: 'sm' | 'md' | 'lg' }) => {
  const sizeClass = {
    sm: 'size-4',
    md: 'size-6',
    lg: 'size-8',
  }[size];
  return <Loading01Icon className={cn('animate-spin', sizeClass)} />;
};

export { Spinner };
